module.exports = __webpack_public_path__ + "static/media/webbanner.8cfae17d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/resources/video/webbanner.mp4
// module id = 559
// module chunks = 0